module.exports = __webpack_public_path__ + "img/zjtx.5d1a10b1.png";